module.exports = __webpack_public_path__ + "images/Technology_Sector-75db1e.png";